<template>
    <el-popover
    placement="top"
    width="160"
    v-model="visible">
    <p>这是一段内容这是一段内容确定删除吗？</p>
    <div style="text-align: right; margin: 0">
        <el-button size="mini" type="text" @click="visible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="visible = false">确定</el-button>
    </div>
    <i :class="icon" slot="reference"></i>
    </el-popover>
</template>

<script>
    export default {
        props:{
           icon:{
               type: String,
               default: 'el-icon-edit'
           }
        },
        data(){
            return {
                visible: false
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>